// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".9305c72492aa0f335b85da5897fc9cc3fe18e570.chunk.bundle.js";
};